module.exports = __webpack_public_path__ + "static/img/MT.791bdef4.svg";